/**
 * Tolerant matching of an extracted source key to a destination requirement key
 * for PDF auto-mapping.
 *
 * The PDF auto-map pre-selects a dropdown when an extracted record key equals the
 * standard requirement key. The LLM usually emits the exact standard key, but on
 * scanned/vision-only documents the output varies (e.g. "Electricity Consumption"
 * vs "ElectricityConsumption", "Start_Date" vs "StartDate"). Exact equality then
 * silently fails and nothing auto-maps. This helper falls back to a normalized
 * comparison (lowercase, strip non-alphanumerics) so formatting drift still maps.
 *
 * It never does fuzzy/semantic guessing — only formatting-insensitive equality —
 * so it cannot mis-map a genuinely different field.
 */

// Lowercase and strip everything except a-z0-9, so "Start Date" / "start_date"
// / "StartDate" all collapse to "startdate".
export function normalizeKey(key) {
  return String(key == null ? "" : key).toLowerCase().replace(/[^a-z0-9]/g, "");
}

// Returns the source key that maps to requirementKey: exact (case-insensitive)
// match first, then normalized match. Returns "" when nothing matches.
export function findSourceKeyForRequirement(requirementKey, sourceKeys) {
  const keys = Array.isArray(sourceKeys) ? sourceKeys : [];
  const target = String(requirementKey == null ? "" : requirementKey);

  const exact = keys.find((k) => String(k).toLowerCase() === target.toLowerCase());
  if (exact) return exact;

  const normTarget = normalizeKey(target);
  if (!normTarget) return "";
  const normMatch = keys.find((k) => normalizeKey(k) === normTarget);
  return normMatch || "";
}
